(function() { window.GUID_7318e43d_d12b_4883_8327_dee9d2801bc7 = { getGuid: function() { return "7318e43d-d12b-4883-8327-dee9d2801bc7"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        /**
         * The CoinFlipper control allows to flip a coin and get the result.
         * It also allows to set player choices and get the result of the flip.
         */
        class CoinFlipper extends Controls.ControlBase {
            get ControlId() {
                return this.controlId;
            }
            get $Control() {
                return $(`#${this.controlId}`);
            }
            /**
             *
             * @param controlId
             * @param params params[1] = animationDuration
             * @param params params[2] = homePersonaId
             * @param params params[3] = awayPersonaId
             */
            constructor(controlId, ...params) {
                super(controlId, ...params);
                this.result = undefined;
                this.animationDuration = 3000;
                this.history = [];
                this.homePersonaId = undefined;
                this.homePlayer = undefined;
                this.awayPersonaId = undefined;
                this.awayPlayer = undefined;
                this.playerChoices = undefined;
            }
            OnControlInstantiation(params) {
                this.controlId = params[0];
                const animationDuration = params[1];
                if (animationDuration) {
                    this.animationDuration = animationDuration;
                }
                this.headsTextureSrc = params[1];
                this.tailsTextureSrc = params[2];
                this.homePersonaId = params[3];
                if (this.homePersonaId) {
                    this.homePlayer = {
                        personaId: this.homePersonaId,
                        // TODO: Get player name and avatar
                    };
                }
                this.awayPersonaId = params[4];
                if (this.awayPersonaId) {
                    this.awayPlayer = {
                        personaId: this.awayPersonaId,
                        // TODO: Get player name and avatar
                    };
                }
                this.$displayWinnerElement = this.$Control.find(`.flip-message`);
                const coinContainerId = this.controlId + "-coin";
                const $coinContainer = this.$Control.find(`#${coinContainerId}`);
                if (!$coinContainer.length) {
                    const minSize = "200px";
                    this.$Control.append(`<div id="${coinContainerId}" style="min-width: ${minSize}; min-height: ${minSize};"></div>`);
                }
                this.coin = new CS.Controls.Coin(coinContainerId, this.headsTextureSrc, this.tailsTextureSrc);
            }
            OnBindEvents() {
                this.coin.$Control.offon("click.coin", this.onCoinClick.bind(this));
                this.coin.$Control.offon("coin-flipped.coin", this.onCoinFlipped.bind(this));
            }
            OnDispose() { }
            OnControlRendered() { }
            onCoinClick(event, isFlipping) {
                try {
                    if (isFlipping) {
                        return;
                    }
                    this.hideWinnerMessage();
                    this.coin.flip();
                }
                catch (error) {
                    console.error("Error while handling coin click", error);
                }
            }
            onCoinFlipped(event, side) {
                try {
                    const winner = this.getWinner(side);
                    this.result = {
                        side: side,
                        player: typeof winner === "string" ? undefined : winner,
                    };
                    this.history.push(this.result);
                    this.showResultMessage();
                }
                catch (error) {
                    console.error("Error while handling coin flipped", error);
                }
            }
            showResultMessage() {
                var _a;
                try {
                    if (!this.result) {
                        return;
                    }
                    const resultMessage = ((_a = this.result.player) === null || _a === void 0 ? void 0 : _a.personaId) || this.getSideName(this.result.side);
                    this.$displayWinnerElement.text(resultMessage);
                    this.$displayWinnerElement.css("opacity", "1");
                    setTimeout(() => {
                        this.$displayWinnerElement.css("opacity", "0");
                    }, 2500);
                }
                catch (error) {
                    console.error("Error while displaying winner", error);
                }
            }
            getSideName(side) {
                try {
                    if (side === "heads") {
                        return JSRess.CoinSide__Heads;
                    }
                    else {
                        return JSRess.CoinSide__Tails;
                    }
                }
                catch (error) {
                    console.error("Error while getting side name", error);
                    return side;
                }
            }
            hideWinnerMessage() {
                try {
                    this.$displayWinnerElement.css("opacity", "0");
                }
                catch (error) {
                    console.error("Error while hiding winner message", error);
                }
            }
            getWinner(side) {
                try {
                    const player = this.getPlayer(side);
                    if (!player) {
                        return side;
                    }
                    return player;
                }
                catch (error) {
                    console.error("Error while getting winner", error);
                }
            }
            GetHistory() {
                return this.history;
            }
            getPlayer(side) {
                try {
                    if (!this.playerChoices) {
                        return undefined;
                    }
                    if (this.playerChoices.home === side) {
                        return this.homePlayer;
                    }
                    else if (this.playerChoices.away === side) {
                        return this.awayPlayer;
                    }
                    return undefined;
                }
                catch (error) {
                    console.error("Error while getting player", error);
                    return undefined;
                }
            }
            setPlayerChoice(side, choice) {
                try {
                    if (!this.playerChoices) {
                        this.playerChoices = { home: undefined, away: undefined };
                    }
                    const oppositeChoice = choice === "heads" ? "tails" : "heads";
                    if (side === "home") {
                        this.playerChoices.home = choice;
                        this.playerChoices.away = oppositeChoice;
                    }
                    else {
                        this.playerChoices.away = choice;
                        this.playerChoices.home = oppositeChoice;
                    }
                }
                catch (error) {
                    console.error("Error while setting player choice", error);
                }
            }
            reset() {
                this.result = undefined;
                this.playerChoices = undefined;
            }
        }
        Controls.CoinFlipper = CoinFlipper;
        (function (CoinFlipper) {
            class Events {
                static CoinFlipped(param) {
                    Controls.RegisterEvent(CoinFlipper, EventNames.CoinFlipped, param);
                }
            }
            CoinFlipper.Events = Events;
            class EventNames {
            }
            EventNames.CoinFlipped = "coin-flipped";
            CoinFlipper.EventNames = EventNames;
        })(CoinFlipper = Controls.CoinFlipper || (Controls.CoinFlipper = {}));
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=coin-flipper.js.map
